import { usePropertyField } from '../usePropertyField';
import { IApplicationNonRental } from '@apply/api/src/api/ApplyApi';

// ─── NonRental – Boolean Flags ────────────────────────────────────────────────

export const usePropertyIsAcquisitionFinancing = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.isAquisitionFinancing,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), isAquisitionFinancing: v } as IApplicationNonRental })
    );

export const usePropertyConstructionStarted = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.constructionStarted,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), constructionStarted: v } as IApplicationNonRental })
    );

export const usePropertyPreSold = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.preSold,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), preSold: v } as IApplicationNonRental })
    );

export const usePropertyIsForeclosure = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.isForeclosure,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), isForeclosure: v } as IApplicationNonRental })
    );

export const usePropertyShortTermRentalLease = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.shortTermRentalLease,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), shortTermRentalLease: v } as IApplicationNonRental })
    );

export const usePropertyGeneralContractorWillWork = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.generalContractorWillWork,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), generalContractorWillWork: v } as IApplicationNonRental })
    );

export const usePropertyHoaDues = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.hoaDues,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), hoaDues: v } as IApplicationNonRental })
    );

export const usePropertyExpandingConditionedSqFt = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.expandingConditionedSqFt,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), expandingConditionedSqFt: v } as IApplicationNonRental })
    );

export const usePropertyMakingStructuralChanges = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.makingStructuralChanges,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), makingStructuralChanges: v } as IApplicationNonRental })
    );

export const usePropertyBuildType = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.buildType,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), buildType: v } as IApplicationNonRental })
    );

export const usePropertyUndergroundStorageTanks = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.undergroundStorageTanks,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), undergroundStorageTanks: v } as IApplicationNonRental })
    );
